import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../../request-on-behalf-details.component";
import Translation from "../../../../../../common/translation/translation.component";
import Icons from "../../../../../../icon";
import { CIRCUIT_STATUS } from "../../../../../../../constants/external-constants";
export class WirelineUpdatePlanDetails extends Component {

    displayPlanComponents = (props) => {
        const { PlanComponents, Currency } = this.props.data?.Subscription?.PlanDetails || {};
        if (!PlanComponents || PlanComponents.length === 0) {
            return null;
        }

        return PlanComponents.map((item, i) => (
            <tr key={i}>
                <td>{i === 0 ? <Translation translationKey="plan_component" /> : null}</td>
                <td>
                    {`${item.ComponentName} | ${item.ComponentCost} | ${Currency.CurrencyName}`}
                </td>
            </tr>
        ));
    };

    displayCurrentPlanComponents = (props) => {
        const { PlanComponents } = this.props.data?.Subscription?.CurrentSubscriptionModel || {};
        const { Currency } = this.props.data?.Subscription?.PlanDetails || {};
        if (!PlanComponents || PlanComponents.length === 0) {
            return null;
        }

        return PlanComponents.map((item, i) => (
            <tr key={i}>
                <td>{i === 0 ? <Translation translationKey="current_plan_component" /> : null}</td>
                <td>
                    {`${item.ComponentName} | ${item.ComponentCost} | ${Currency.CurrencyName}`}
                </td>
            </tr>
        ));
    };

    render() {
        const { data, isWireline, isAllowUpdate, openRequestModal  } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType } }} = data || {};
        return (
            <div>               
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                {isAllowUpdate() ?  
                          <Icons
                          customClassName="pen-to-square"
                          name="pen-to-square"
                          size="20px"
                          containerClass="icon-circle-plus-container"
                          onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                          labelValue={"Update Order Request"}
                          labelClass="order-detail-edit-label"                                                              
                        />

                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>     
                    {data.Order.IsRequestedInBehalf ?
                        <Table className="mb-0">
                            <tbody>
                                <tr>
                                    <td className="order-detail-location-title pt-0"><RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} /></td>
                                </tr>
                            </tbody>
                        </Table>
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                          
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit?.CircuitCode || ''}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className={data.Circuit.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Circuit.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Circuit?.CircuitStatus || ''}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription?.Vendor || ''}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription?.CircuitType || ''}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription?.SubCircuitType || ''}</td>
                            </tr>
                             <tr>
                                <td><Translation translationKey="current_plan" /></td>
                                <td>{data.Subscription.CurrentSubscriptionModel?.Plan || ''}</td>
                            </tr>
                            {this.displayCurrentPlanComponents(data.Subscription.PlanDetails.PlanComponents === null ? data.NewRequest.PlanDetails.PlanComponents : data.Subscription.PlanDetails.PlanComponents.slice(0, 1))}
                            <tr>
                                <td><Translation translationKey="current_plan_cost" /></td>
                                <td>{data.Subscription.CurrentSubscriptionModel.TotalComponentCost}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="update_plan_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.Subscription?.PlanDetails?.PlanName || ''}</td>
                            </tr>
                            {this.displayPlanComponents(data.Subscription.PlanDetails.PlanComponents === null ? data.NewRequest.PlanDetails.PlanComponents : data.Subscription.PlanDetails.PlanComponents.slice(0, 1))}
                            <tr>
                                <td><Translation translationKey="total_plan_cost" /></td>
                                <td>{data.Subscription?.TotalComponentCost || ''}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.WireLineApprover?.Email || ''}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification?.BusinessJustification || ''}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification?.AdditionalInformation || ''}</td>
                            </tr>
                        </tbody>
                    </Table>
                  
                </div>
            </div>
        );
    }
}